export default __webpack_public_path__ + "static/media/blue.a8364c67.png";